import { useQuery } from '@tanstack/react-query';
import { configService } from '../services/config.service';

export function useFeatureFlags() {
  const query = useQuery({
    queryKey: ['feature-flags'],
    queryFn: () => configService.getFeatureFlags(),
    staleTime: 5 * 60 * 1000, // 5 minutes - flags change rarely
  });

  return {
    useDummyDataWhenEmpty: query.data?.useDummyDataWhenEmpty ?? false,
    showQuickActions: query.data?.showQuickActions ?? false,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
